(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/banner-grid-item/views/header-logotype.js') >= 0) return;  svs.modules.push('/components/lb-ui/banner-grid-item/views/header-logotype.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lb_ui=_svs.lb_ui||{};
_svs.lb_ui.banner_grid_item=_svs.lb_ui.banner_grid_item||{};
_svs.lb_ui.banner_grid_item.templates=_svs.lb_ui.banner_grid_item.templates||{};
svs.lb_ui.banner_grid_item.templates.header_logotype = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"banner-grid-header-logotype banner-grid-header-logotype-"
    + alias3(((helper = (helper = lookupProperty(helpers,"branding") || (depth0 != null ? lookupProperty(depth0,"branding") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"branding","hash":{},"data":data,"loc":{"start":{"line":1,"column":68},"end":{"line":1,"column":80}}}) : helper)))
    + "\">\n  "
    + alias3((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||alias2).call(alias1,"brands",{"name":"ui","hash":{"emblem":true,"brand":(depth0 != null ? lookupProperty(depth0,"branding") : depth0)},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":45}}}))
    + "\n</div>\n";
},"useData":true});
Handlebars.partials['components-lb_ui-banner_grid_item-header_logotype'] = svs.lb_ui.banner_grid_item.templates.header_logotype;
})(svs, Handlebars);


 })(window);